import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { SnackbarTypes } from 'src/app/core/_enums/snackbar.types';
import { User } from 'src/app/core/_models/user';
import { AccountService } from 'src/app/core/_services/account.service';
import { SnackbarService } from 'src/app/core/_services/snackbar.service';
import { SpinnerOverlayService } from 'src/app/core/_services/spinner.overlay.service';
import { UserService } from 'src/app/core/_services/user.service';
import CheckPassValidation from 'src/app/core/_utils/validation';
import { UserAccountConstants } from 'src/constants/useraccount.constants';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  form!: FormGroup;
  private resetPasswordToken!: string;

  constructor(
    private activeRoute: ActivatedRoute,
    private accountService: AccountService,
    private formBuilder: FormBuilder,
    private userService: UserService,
    private snackbarService: SnackbarService,
    private spinnerService: SpinnerOverlayService,
    public USER_ACCOUNT_CONSTANTS: UserAccountConstants
  ) {
    this.form = this.formBuilder?.group(
      {
        userId: [],
        userName: [{ value: null, disabled: true }],
        userLogin: [{ value: null, disabled: true }],
        userFirstName: [{ value: null, disabled: true }],
        email: [{ value: null, disabled: true }],
        status: [{ value: null, disabled: true }],
        password: ['', [Validators.required, Validators.minLength(8), Validators.pattern(this.USER_ACCOUNT_CONSTANTS.PasswordPattern)]],
        confirmPassword: ['', [Validators.required, Validators.minLength(8), Validators.pattern(this.USER_ACCOUNT_CONSTANTS.PasswordPattern)]]
      },
      {
        validators: [CheckPassValidation.match('password', 'confirmPassword')]
      }
    );
  }

  ngOnInit(): void {
    this.spinnerService.show();

    this.activeRoute.params.subscribe(
      (params) => {
        this.resetPasswordToken = params?.id;
        if (params?.id != '0') {
          this.accountService.getUserByResetPasswordTokenId(params?.id).subscribe((user) => {
            if (user) this.form.patchValue(user);
            else this.snackbarService.open(SnackbarTypes.resetPasswordTokenExpired);
            setTimeout(() => {
              this.spinnerService.hide();
            }, 500);
          });
        } else {
          this.form.patchValue({});
        }
      },
      (error) => {
        this.snackbarService.open(SnackbarTypes.error);
        this.spinnerService.hide();
      },
      () => {
        this.spinnerService.hide();
      }
    );
  }

  get formCrls() {
    return this.form?.controls;
  }

  clickSave(user: User) {
    if (this.form.invalid) {
      return;
    }
    this.accountService.updateUserPassword(this.resetPasswordToken, user.password!).subscribe(
      (rep) => {
        this.snackbarService.open(SnackbarTypes.add);
        this.form.patchValue(rep);
      },
      (error) => {
        this.snackbarService.open(error.status == 400 ? SnackbarTypes.resetPasswordTokenExpired : SnackbarTypes.error);
      }
    );
  }

  addValidators(frm: any) {
    frm.password.setValidators([Validators.required, Validators.minLength(8), Validators.pattern(this.USER_ACCOUNT_CONSTANTS.PasswordPattern)]);
    frm.confirmPassword.setValidators([Validators.required, Validators.minLength(8), Validators.pattern(this.USER_ACCOUNT_CONSTANTS.PasswordPattern)]);
    frm.password.updateValueAndValidity();
    frm.confirmPassword.updateValueAndValidity();
  }
}
